export const formDynamicBuckets = (buckets, colors, rbpLayer = 'index') => {
  const property = rbpLayer === 'index' ? 'index_main' : 'people_main';
  const formatedBuckets = [];

  buckets.forEach((item, index) => {
    if (index === 0) return;
    if (index === 1) {
      formatedBuckets.push(['<', ['get', property], item]);
    } else {
      let value = item;
      if (index === buckets.length - 1) {
        value = item + 1;
      }
      formatedBuckets.push([
        'all',
        ['>=', ['get', property], buckets[index - 1]],
        [
          '<',
          ['get', property],
          index === buckets.length - 1 ? value + 1 : value,
        ],
      ]);
    }
  });

  const result = [
    'case',
    ['all', ['==', ['get', property], null]],
    'rgba(213,213,213,0.7)',
  ];

  formatedBuckets.forEach((item, index) => {
    result.push(item, colors[index]);
  });
  result.push('rgba(0,0,0,0.7)');
  return result;
};

export const changeIndexMain = (features, property) => {
  return features.map((item) => {
    return {
      ...item,
      properties: {
        ...item.properties,
        index_main: item.properties[property],
      },
    };
  });
};
